import React from 'react';
import { Button, Typography } from '@material-ui/core';
import { AuthRoles, readableSchemeTypes, Roles, SchemeTypes } from 'config';
import { Control, useForm, DeepMap, FieldError } from 'react-hook-form';
import TranslatedText from '../../../../components/atoms/translated_text';
import {
  AppSelect,
  AppTextField,
  AppSwitch,
} from '../../../../components/molecules/form_controls';
import GridLayout from '../../../../components/molecules/grid_layout';
import { Translations } from '../../configuration';
import _ from 'lodash';
import { useHistory } from 'react-router';
import NavigationConfig from 'navigation/config';
import * as ReimbursementsListSelectors from 'redux/reducers/reimbursements_list_reducer/selectors';
import * as PaymentsReceivedListSelectors from 'redux/reducers/payments_received_list_reducer/selectors';

interface FormFields {
  paymentRef: string | null;
  schemeType: string | null;
  msconCountry: string | null;
}

interface IProps {
  paymentRef: string | null;
  schemeType: string | null;
  msconCountry: string | null;
  role: Roles;
}

const FilterForm = (props: IProps) => {
  const history = useHistory();

  const defaultValues = {
    paymentRef: props.paymentRef ? props.paymentRef : null,
    schemeType: props.schemeType ? props.schemeType : null,
    msconCountry: props.msconCountry ? props.msconCountry : null,
  };
  const { control, errors, handleSubmit, reset } = useForm<FormFields>({
    defaultValues: defaultValues,
  });

  const onSubmit = (data: any) => {
    let query = [];
    if (data.paymentRef)
      query.push({
        key: 'paymentRef',
        value: data.paymentRef,
      });
    if (data.schemeType)
      query.push({
        key: 'schemeType',
        value: data.schemeType,
      });
    if (data.msconCountry)
      query.push({
        key: 'msconCountry',
        value: data.msconCountry,
      });
    let queryString = '';
    query.map((query, index) => {
      if (index == 0) queryString += `?${query.key}=${query.value}`;
      else queryString += `&${query.key}=${query.value}`;
    });
    history.push(NavigationConfig.paymentInfoPage().path + queryString);
  };

  const clearFilter = () => {
    history.push(NavigationConfig.paymentInfoPage().path);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ marginBottom: '0.6rem' }}>
      <GridLayout
        elements={
          [
            {
              element: renderPaymentReferenceField(errors, control),
              size: 3,
              id: 'paymentRef',
            },
            {
              element: renderSchemeTypeField(errors, control),
              size: 3,
              id: 'schemeType',
            },
            {
              element: renderMsconCountryField(errors, control),
              size: 3,
              id: 'msconCountry',
            },
            // {
            //   element: <span></span>,
            //   size: 1,
            //   id: 'space',
            // },
            {
              element: (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    style={{
                      width: '47%',
                      marginTop: '0.6rem',
                      marginRight: '0.25rem',
                    }}
                  >
                    <TranslatedText textMap={Translations.search} />
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{
                      width: '47%',
                      marginTop: '0.6rem',
                      marginLeft: '0.25rem',
                    }}
                    onClick={clearFilter}
                  >
                    <TranslatedText textMap={Translations.clear} />
                  </Button>
                </div>
              ),
              size: 3,
              id: 'search',
            },
          ] as any
        }
      />
    </form>
  );
};

const renderPaymentReferenceField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  return (
    <AppTextField
      variant="outlined"
      fullWidth
      id="paymentRef"
      label={<TranslatedText textMap={Translations.payment_reference} />}
      error={'paymentRef' in errors}
      name="paymentRef"
      control={control}
      rules={{}}
      helperText={errors.paymentRef && errors.paymentRef.message}
    />
  );
};

const renderSchemeTypeField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  const schemeTypes = ['MOSS', 'VOES', 'IMPORT'];
  let select_options = [];
  select_options.push({
    id: '',
    label: Translations.schemeType.English,
  });
  for (let schemeType of schemeTypes) {
    select_options.push({
      id: schemeType,
      label: _.get(readableSchemeTypes, schemeType),
    });
  }
  return (
    <AppSelect
      variant="outlined"
      fullWidth
      label={<TranslatedText textMap={Translations.schemeType} />}
      id="schemeType"
      name="schemeType"
      error={'schemeType' in errors}
      control={control}
      rules={{}}
      options={select_options as any}
      helperText={errors.schemeType && errors.schemeType.message}
    />
  );
};

const renderMsconCountryField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  let countries = PaymentsReceivedListSelectors.useGetMemberStateCountries();
  let select_countries = [];
  select_countries.push({
    id: '',
    label: 'MSCON Country',
  });
  if (countries && countries.length > 0)
    for (let country of countries)
      select_countries.push({
        id: country.code,
        label: `${country.code} - ${country.description}`,
      });
  return (
    <AppSelect
      variant="outlined"
      fullWidth
      label={<TranslatedText textMap={Translations.msconCountry} />}
      id="msconCountry"
      name="msconCountry"
      error={'msconCountry' in errors}
      control={control}
      rules={{}}
      options={select_countries as any}
      helperText={errors.msconCountry && errors.msconCountry.message}
    />
  );
};

export default FilterForm;
